module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [(_vm.item) ? _c('div', {
    staticClass: "bd"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('span', {
    staticClass: "contractNumber",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("合同号：" + _vm._s(_vm.item.contractNo))]), _vm._v(" "), _c('div', {
    staticClass: "tagWrap"
  }, [_c('span', {
    staticClass: "tag",
    attrs: {
      "id": "tag-copy",
      "data-clipboard-text": _vm.item.contractNo,
      "lines": undefined
    },
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("复制")])])]), _vm._v(" "), (_vm.sfQuoteNo !== undefined && _vm.sfQuoteNo !== null) ? _c('div', {
    staticClass: "group"
  }, [(_vm.sfQuoteNo) ? _c('span', {
    staticClass: "contractNumber",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("报价编号：" + _vm._s(_vm.sfQuoteNo))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tagWrap"
  }, [_c('span', {
    staticClass: "tag",
    attrs: {
      "id": "tag-copy1",
      "data-clipboard-text": _vm.sfQuoteNo,
      "lines": undefined
    },
    on: {
      "click": _vm.copysfQuoteNo
    }
  }, [_vm._v("复制")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "empty"
  }), _vm._v(" "), (_vm.item.fromEmkt) ? _c('div', {
    staticClass: "container_3"
  }, [_c('img', {
    staticClass: "product-label",
    attrs: {
      "src": _vm.emkt.getMerchandiseLabelPath(_vm.item)
    }
  }), _vm._v(" "), (_vm.item.merchandiseIcon) ? _c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": _vm.baseurl + _vm.item.merchandiseIcon
    }
  }) : (_vm.item.categoryId === 20 || _vm.item.categoryId === 10) ? _c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": _vm.baseurl + _vm.emkt.CUSTOMIZE_IMAGE
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container_2"
  }, [(_vm.item._titleList && _vm.item._titleList.length > 0) ? _c('span', {
    staticClass: "lentivirus deep-text-color text-overflow-hidden",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._l((_vm.item._titleList), function(title) {
    return _c('span', [(title.valueText && title.valueText !== '-1' && title.value !== '-1') ? _c('span', [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))]), _vm._v(" ")]) : _vm._e()])
  }), _vm._v(" "), (_vm.item._subTitleList && _vm.item._subTitleList.length > 0) ? _c('span', {
    staticClass: "gfpPuromycin light-text-color tiny-font text-overflow-hidden"
  }, _vm._l((_vm.item._subTitleList), function(subTitle, index) {
    return _c('span', [(index !== 0) ? _c('span', [_vm._v("/")]) : _vm._e(), _vm._v(" "), (subTitle.valueText && subTitle.valueText !== '-1' && subTitle.value !== '-1') ? _c('span', [_vm._v(_vm._s(subTitle.valueText))]) : _vm._e()])
  }), 0) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.item._abstractList && _vm.item._abstractList.length > 0) ? _c('span', {
    staticClass: "humanatgnm light-text-color tiny-font text-overflow-hidden"
  }, _vm._l((_vm.item._abstractList), function(abstractTitle, index) {
    return _c('span', [(abstractTitle.valueText && abstractTitle.valueText !== '-1' && abstractTitle.value !== '-1' && abstractTitle.valueText.TLNo !== undefined) ? _c('span', [(abstractTitle.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(abstractTitle.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(abstractTitle.valueText))]), _vm._v(" ")]) : _vm._e()])
  }), 0) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "word light-text-color"
  }, [_vm._v("X " + _vm._s(_vm.item.quantity))])]) : _c('div', {
    staticClass: "container_3"
  }, [(_vm.item.merchandiseIcon) ? _c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": _vm.baseurl + _vm.item.merchandiseIcon
    }
  }) : (_vm.item.categoryId === 20 || _vm.item.categoryId === 10) ? _c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": _vm.baseurl + _vm.emkt.CUSTOMIZE_IMAGE
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container_2"
  }, [_c('span', {
    staticClass: "lentivirus text-overflow-hidden",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.item.name) + " "), _c('span', {
    staticClass: "gfpPuromycin",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.item.TLNo) + " " + _vm._s(_vm.item.tag1PUBID) + " " + _vm._s(_vm.item.eu_RID))])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.tax !== '' && _vm.item.tax !== undefined),
      expression: "item.tax!==''&&item.tax!==undefined"
    }],
    staticClass: "humanatgnm text-overflow-hidden",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v(_vm._s(_vm.item.tax) + "/" + _vm._s(_vm.item.symbol) + "/" + _vm._s(_vm.item.nm_ID))])]), _vm._v(" "), _c('span', {
    staticClass: "word",
    attrs: {
      "lines": undefined
    }
  }, [_vm._v("X " + _vm._s(_vm.item.quantity))])])]) : _vm._e(), _vm._v(" "), (_vm.showDefaultImage) ? _c('div', {
    staticClass: "bd",
    staticStyle: {
      "height": "300px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/img/进展空.png"
    }
  })]) : _c('task-progress', {
    attrs: {
      "type": _vm.type,
      "taskModules": _vm.taskModules,
      "expressOutList": _vm.expressOutList
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-710761d2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/User/MyResearchGroup/researchGroupProgress/ToolProgress.vue
// module id = 1675
// module chunks = 8